// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__6Tusx","arrows":"styles_arrows__Tfggl","shadow":"styles_shadow__ZOjgi","slider__wrapper":"styles_slider__wrapper__JcOLC"};